import {
  ResponsiveContainer,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  Radar,
  Tooltip,
} from 'recharts';
import type { EvaluationCriteria } from '@/types/stock';

interface Props {
  criteria: EvaluationCriteria[];
  height?: number;
}

export function ScoreRadarChart({ criteria, height = 280 }: Props) {
  const data = criteria.map((c) => ({
    subject: c.label.length > 18 ? c.label.slice(0, 16) + '…' : c.label,
    score: c.passed === true ? 100 : c.passed === false ? 0 : 50,
    fullMark: 100,
  }));

  const CustomTooltip = ({ active, payload }: {
    active?: boolean;
    payload?: Array<{ payload: { subject: string }; value: number }>;
  }) => {
    if (!active || !payload?.length) return null;
    const item = payload[0];
    const criterion = criteria.find((c) => c.label.startsWith(item.payload.subject.replace('…', '')));
    return (
      <div className="bg-card border border-border rounded-lg p-3 shadow-lg text-xs max-w-[200px]">
        <p className="font-semibold mb-1">{criterion?.label}</p>
        <p className={criterion?.passed === true ? 'text-emerald-500' : criterion?.passed === false ? 'text-red-500' : 'text-amber-500'}>
          {criterion?.passed === true ? '✓ PASS' : criterion?.passed === false ? '✗ FAIL' : '? N/A'}
        </p>
        {criterion?.value !== null && (
          <p className="text-muted-foreground mt-1">Value: {criterion?.value?.toFixed(1)}</p>
        )}
      </div>
    );
  };

  return (
    <div className="w-full">
      <h3 className="text-sm font-semibold text-muted-foreground mb-3 uppercase tracking-wide">
        Criteria Score
      </h3>
      <ResponsiveContainer width="100%" height={height}>
        <RadarChart data={data} margin={{ top: 0, right: 20, bottom: 0, left: 20 }}>
          <PolarGrid stroke="hsl(var(--border))" />
          <PolarAngleAxis
            dataKey="subject"
            tick={{ fontSize: 10, fill: 'hsl(var(--muted-foreground))' }}
          />
          <Radar
            name="Score"
            dataKey="score"
            stroke="#3b82f6"
            fill="#3b82f6"
            fillOpacity={0.25}
            strokeWidth={2}
          />
          <Tooltip content={<CustomTooltip />} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
